import { Breadcrumbs } from "./Breadcrumbs";
import { PlayerName } from "./PlayerName";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { formatBalance } from ".././../utils/formatters";
import styled from "styled-components";
import { useState } from "react";

const TransferBox = styled.span`
  background-color: ${({ selected }) => (selected ? "#a5ffb4" : "#f8e7ff8a")};
  box-shadow: 0 0 0.35rem #000a;
  border: 1px solid black;
  border-radius: 5px;
  padding: 0.25rem 1rem;
  min-height: 4rem;
  min-width: 12rem;
  margin: 0.5rem 0.25rem;
  display: flex;
  flex-direction: column;
`;

export const Transfer = ({ transfer }) => {
  const [selected, setSelected] = useState(false);

  return (
    <CopyToClipboard
      text={`transfer ${transfer.amount} to ${transfer.to}`}
      onCopy={() => {
        setSelected((selected) => !selected);
      }}
    >
      <TransferBox selected={selected}>
        <PlayerName>
          <Breadcrumbs>do:</Breadcrumbs> {transfer.to}
        </PlayerName>
        <Breadcrumbs>{formatBalance(transfer.amount)}</Breadcrumbs>
      </TransferBox>
    </CopyToClipboard>
  );
};
